<template>
    <div class="account-content">
            <div class="container">
                <div class="account-box">
                    <div class="account-wrapper">
                        <h3 class="account-title">Forgot Password?</h3>
                        <p class="account-subtitle">Enter your email to get a password reset link</p>

                        <form>
                            <div class="form-group">
                                <label>Email Address</label>
                                <input class="form-control" type="text">
                            </div>
                            <div class="form-group text-center">
                                <button class="btn btn-primary account-btn" type="submit">Reset Password</button>
                            </div>
                            <div class="account-footer">
                                <p>Remember your password? <a href="index.html">Login</a></p>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </div>
</template>

<script>
export default {
    data(){
        return{
        }
    },
    created() {
        document.getElementById("body").classList.remove("account-page");
    },
    methods:{
        login(){
            this.$router.push({path:"/dashboard"});
        }
    }
}
</script>
